import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import moment from 'moment'
import DayPicker from 'react-day-picker'
import MomentLocaleUtils from 'react-day-picker/moment'

import styles from './styles.css'

moment.locale('sv')

/**
 * For all available options see plugin documentation
 * @link http://react-day-picker.js.org/docs/getting-started/
 */

export const PropCalendarDays = PropTypes.oneOfType([
  PropTypes.instanceOf(Date),
  PropTypes.instanceOf(moment),
  PropTypes.object,
  PropTypes.arrayOf(PropTypes.object),
  PropTypes.func,
])

class Calendar extends Component {
  static propTypes = {
    className: PropTypes.string,
    initialMonth: PropTypes.object,
    selectedDays: PropCalendarDays,
    highlightedDays: PropCalendarDays,
    bookedDates: PropCalendarDays,
    disabledDays: PropCalendarDays,
    onDayClick: PropTypes.func,
    modifiers: PropTypes.array,
    monthLarge: PropTypes.bool,
    onChange: PropTypes.func,
    cover: PropTypes.string,
  }

  static defaultProps = {
    monthLarge: false,
    className: '',
    initialMonth: new Date(),
    selectedDays: [],
    highlightedDays: [],
    bookedDates: [],
    disabledDays: [],
    modifiers: [],
    onDayClick: (day, types) => console.log('onDayClick', day, types),
    onChange: () => {},
    cover: undefined,
  }

  onDayClick = (day, selectors, e) => {
    if (
      selectors[styles.disabled] ||
      selectors[styles.past] ||
      selectors[styles.outside] ||
      selectors[styles.bookedDates]
    ) {
      return
    }
    const { onChange } = this.props
    this.props.onDayClick(day, selectors, e, onChange)
  }

  getClassName() {
    return classnames(styles.calendarRoot, this.props.className)
  }

  render() {
    const {
      className,
      initialMonth,
      selectedDays,
      highlightedDays,
      disabledDays,
      bookedDates,
      onDayClick,
      modifiers,
      monthLarge,
      cover,
      ...restProps
    } = this.props

    const classes = monthLarge
      ? { ...styles, month: styles.monthLarge }
      : styles
    return (
      <div className={styles.root}>
        <DayPicker
          localeUtils={MomentLocaleUtils}
          locale="sv"
          classNames={classes}
          modifiers={{
            [styles.saturdays]: { daysOfWeek: [6] },
            [styles.sundays]: { daysOfWeek: [0] },
            [styles.bookedDates]: bookedDates,
            ...(modifiers || {}),
          }}
          className={this.getClassName()}
          initialMonth={initialMonth}
          selectedDays={[...selectedDays, ...highlightedDays]}
          disabledDays={disabledDays}
          onDayClick={this.onDayClick}
          showOutsideDays
          fixedWeeks
          {...restProps}
        />
        {cover != null && <div className={styles.cover}>{cover}</div>}
      </div>
    )
  }
}

export default Calendar



// WEBPACK FOOTER //
// ../source/components/Calendar/index.js